import React from 'react';
import openExternalLink from "../../open_external_link";

const TooltipWithLink = ({tooltipText}) => {
    const renderContent = () => {
        const linkMatch = tooltipText?.match(/<a\s+href=["']?([^"'\s>]+)["']?[^>]*>([^<]+)<\/a>/);

        if (!linkMatch) {
            return tooltipText;
        }

        const [fullMatch, href, linkText] = linkMatch;
        const beforeLink = tooltipText.substring(0, tooltipText.indexOf(fullMatch));
        const afterLink = tooltipText.substring(tooltipText.indexOf(fullMatch) + fullMatch.length);

        return (
            <>
                {beforeLink}
                <a
                    className="cursor-pointer"
                    onClick={(e) => {
                        e.preventDefault();
                        openExternalLink(e, 'open-link', href);
                    }}
                >
                    {linkText}
                </a>
                {afterLink}
            </>
        );
    };

    if (!tooltipText) {
        return null;
    }

    return (
      renderContent()
    );
};

export default TooltipWithLink;